/**
 * Matched-term highlighter for global document search. Splits `text` into
 * consecutive segments, flagging the ones that case-insensitively equal `term`,
 * so a caller can wrap the matches in <mark>. Pure + allocation-light; the
 * highlight decision stays in the presentation layer (the server snippet carries
 * no markup). An empty / whitespace-only term yields a single unmatched segment.
 */
export interface HighlightSegment {
  text: string;
  match: boolean;
}

export function highlightSegments(
  text: string,
  term: string,
): HighlightSegment[] {
  const needle = term.trim().toLowerCase();
  if (!needle) return [{ text, match: false }];

  const segments: HighlightSegment[] = [];
  const hay = text.toLowerCase();
  let i = 0;
  while (i < text.length) {
    const found = hay.indexOf(needle, i);
    if (found === -1) {
      segments.push({ text: text.slice(i), match: false });
      break;
    }
    if (found > i) segments.push({ text: text.slice(i, found), match: false });
    segments.push({ text: text.slice(found, found + needle.length), match: true });
    i = found + needle.length;
  }
  return segments;
}
